import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core'

export default function RemoveDialog({ open, setOpen, name, action }) {
  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm">
      <DialogTitle>{name ? name : 'Remove all Items'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure that you want to remove {name ? 'selected' : 'all'} item?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (!name) {
              if (localStorage.getItem('defaulttip') != null) {
                localStorage.removeItem('defaulttip')
              }
              if (localStorage.getItem('tipamount') != null) {
                localStorage.removeItem('tipamount')
              }
            }
            action()
            setOpen(false)
          }}
        >
          Remove Item{name ? '' : 's'}
        </Button>
        <Button onClick={() => setOpen(false)} color="primary">
          Keep Item{name ? '' : 's'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
